import { db, firebase } from "astrid-firebase";
import createAgreementData from "astrid-firestore/src/api/agreements/createAgreementData";
import runBatch from "astrid-firestore/src/helpers/runBatch";

import { getProfile } from "../../../../authentication/state/profile";

// A signed agreement has one party, and its file goes under the agreement's id. The agreement doesn't exist yet, so
// the file names the first party for the Storage rules.
async function uploadSignedAgreement(bucket, file, firstParty) {
	const ref = db.collection("agreements").doc();

	const signedAgreementFile = await bucket.putFile(
		`agreements/${ref.id}/${Date.now()}.${file.name.split(".").pop()}`,
		file,
		null,
		{ customMetadata: { firstPartyId: firstParty.id } },
	);

	return { ref, signedAgreementFile };
}

export default async function submitAgreements({ signedAgreementFile, ...formData }, bucket) {
	const signed =
		formData.signed && signedAgreementFile
			? await uploadSignedAgreement(bucket, signedAgreementFile, formData.firstParty)
			: null;

	return runBatch(db, (batch) => {
		Object.values(formData.parties)
			.map((secondParty) =>
				createAgreementData(firebase, {
					...formData,
					...signed,
					createdBy: getProfile(),
					secondParty,
				}),
			)
			.forEach((agreement) => batch.set(agreement.ref, agreement));
	});
}
